<template>
    <el-row :gutter="30"  class="mw-100 manage-pages-banner" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentPagesBannerData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addPagesBannerRef"
                            :model="currentPagesBannerData"
                            :rules="currentPagesBannerDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                                <el-col :lg="24" :xs="24">
                                    <el-form-item>
                                        <el-button type="primary" @click="managePagesBanner('addPagesBannerRef',index)" class="text-cap">
                                            <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                            save
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-row :gutter="30">
                                        
                                        <el-col :lg="12" :xs="24">
                                            <el-form-item  label="pagesBanner image" prop="imageBase64">
                                                <el-image 
                                                    style="width: 150px; height: 150px;margin-right:20px" 
                                                    :src="isAddPagesBanner ? currentPagesBannerData.imageURL :  $getImage(currentPagesBannerData.imageURL) || ''" 
                                                    fit="cover"
                                                    :zoom-rate="1.2"
                                                    :preview-src-list="[isAddPagesBanner ? currentPagesBannerData.imageURL : $getImage(currentPagesBannerData.imageURL)]"
                                                    :preview-teleported="true"
                                                >
                                                    <template #error>
                                                        <div class="image-slot">
                                                            <font-awesome-icon :icon="['fas', 'image']" />
                                                        </div>
                                                    </template>
                                                </el-image>
                                                <el-upload
                                                    ref="imageBase64"
                                                    action="#"
                                                    :auto-upload="false"
                                                    :on-change="onUploadImage"
                                                    :disabled="fileUploaded"
                                                    :on-remove="handleRemoveImage"
                                                    accept="image/png, image/jpeg,image/gif"
                                                    class="font-24 d-flex align-center flex-1"
                                                >
                                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                                </el-upload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-card class="h-100">
                                        <el-row :gutter="30">
                                            <el-col :lg="24" :xs="24">
                                                <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                    <el-input type="text" v-model="currentPagesBannerData.translates[index].title"></el-input>    
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :xs="24">
                                                <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                                    <el-input type="textarea" rows="4" v-model="currentPagesBannerData.translates[index].description"></el-input>    
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-col>
                                
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
   
    
</template>

<script>
export default {
    data(){
        return {
           
            fileList:[],
            isAddPagesBanner:true,
            fileUploaded:false,
            currentPagesBannerData:{},
            currentPagesBannerDataRules:{
                translates:this.$setTranslateRules(['title']),
            }
        };
    },
    computed:{
        cachedPagesBanner(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.pagesBanners?.currentPagesBanner || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedPagesBanner.id) {
            this.isAddPagesBanner = false;
            this.currentPagesBannerData = JSON.parse(JSON.stringify(this.cachedPagesBanner));
            this.currentPagesBannerData = this.converUpdatedObj(this.currentPagesBannerData);
            this.currentPagesBannerData.translates = this.$filterPublishedTranslates(this.currentPagesBannerData.translates);
           
        }else{
            this.$router.push({
                name:'manage-pages-banner',
            })
            this.isAddPagesBanner = true;
            this.currentPagesBannerData = this.initState()
            this.currentPagesBannerDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
        }
    },
    
    methods:{
        initState(){
            return {
             
                translates:this.$setTranslateKeys({
                    'description':'',
                    'title':'',
                }),
               
            }
        },
       
        async managePagesBanner(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addPagesBannerRef'].length){
                            this.managePagesBannerAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async managePagesBannerAfterValidate(){
            let clonedData = JSON.parse(JSON.stringify(this.currentPagesBannerData));
            delete clonedData.imageURL;
            
            
            const response = await this.$store.dispatch(this.isAddPagesBanner ? 'addPagesBanner':'editPagesBanner',clonedData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllPagesBanners');
                this.$router.push({
                    name:'pages-banners-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentPagesBannerData.imageBase64 = evt.target.result;
                }); 
                this.currentPagesBannerData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        }, 
        handleRemoveImage(){
            this.currentPagesBannerData.imageURL = this.isAddPagesBanner ? '' : this.cachedPagesBanner.imageURL
        },   
      
        
        converUpdatedObj(oldObj){
            // Copy the object
            let newObj = Object.assign({}, oldObj);
            delete newObj.value;
            delete newObj.image2URL;
            return newObj
        }
    }
}
</script>
<style lang="scss">
    .manage-pages-banner {
        .ck-editor {
            width:100%;
        }
    }
</style>